// extracted by mini-css-extract-plugin
export default {"invite":"ChannelInvite_invite__9yHlT","btn":"ChannelInvite_btn__FSGRB"};